import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import {
  rootRouteRef,
  personalServicesRouteRef,
  modelgardenRouteRef,
  masspRouteRef,
  agentgardenRouteRef,
  mcpgardenRouteRef,
  templatesRouteRef,
  aiplaygroundRouteRef,
  agentictoolingRouteRef,
} from './routes';
import { aiEcosystemApiRef, AiEcosystemClient } from './api';
import { aiResourceApiRef } from './api/airesource.api';
import { aiResourceService } from './services/AIResourceService/AIResourceService';
import { modelGardenApiRef } from './api/modelgarden.api';
import { ModelGardenService } from './services/ModelGardenService/ModelGardenService';
import { agentGardenApiRef } from './api/agentgarden.api';
import { utilityApiRef } from './api/utility.api';
import { UtilityService } from './services/UtilityService/UtilityService';
import { templateApiRef } from './api/template.api';
import { TemplateService } from './services/TemplateService/TemplateService';
import { AgentGardenService } from './services/AgentGardenService/AgentGardenService';
import { mcpGardenApiRef } from './api/mcpgarden.api';
import { McpGardenService } from './services/McpGardenService/McpGardenService';
import { n8nManagerApiRef } from './api/n8nmanager.api';
import { N8nManagerService } from './services/N8nManagerService/N8nManagerService';

export const aiecosystemPlugin = createPlugin({
  id: 'aiecosystem',
  apis: [
    createApiFactory({
      api: aiEcosystemApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiEcosystemClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: aiResourceApiRef,
      deps: {},
      factory: () => aiResourceService,
    }),
    createApiFactory({
      api: modelGardenApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ModelGardenService(discoveryApi, fetchApi),
    }),
    createApiFactory({
      api: agentGardenApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new AgentGardenService(discoveryApi),
    }),
    createApiFactory({
      api: utilityApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new UtilityService(discoveryApi),
    }),
    createApiFactory({
      api: mcpGardenApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new McpGardenService(discoveryApi),
    }),
    createApiFactory({
      api: templateApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TemplateService(discoveryApi, fetchApi),
    }),
    createApiFactory({
      api: n8nManagerApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new N8nManagerService(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
    services: personalServicesRouteRef,
    modelgarden: modelgardenRouteRef,
    massp4ai: masspRouteRef,
    mcpgarden: mcpgardenRouteRef,
    agentgarden: agentgardenRouteRef,
    templates: templatesRouteRef,
    aiplayground: aiplaygroundRouteRef,
    agentictooling: agentictoolingRouteRef,
  },
});

export const AiEcosystemPage = aiecosystemPlugin.provide(
  createRoutableExtension({
    name: 'AiEcosystemPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
